module.exports = __webpack_public_path__ + "static/media/auth-sidebar-bg.c204b21e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/auth-sidebar-bg.png
// module id = 806
// module chunks = 0